import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { selectUser } from "../../redux/slices/auth.slice";

/**
 * Whether the current screen should show the group shell (rail + content)
 * rather than the ordinary single-branch admin shell.
 *
 * A group admin is in group mode BY DEFAULT, and drops out of it only once
 * they are actually on an `/dashboard/admin/...` path — i.e. after they have
 * picked a branch via the branch switcher. That single rule is what makes a
 * fresh login land in the group shell (rather than requiring the header
 * dropdown to find it) while still handing a picked branch its normal,
 * unmodified admin experience, sidebar included.
 *
 * Used identically in DashboardRoutes.js (which content renders) and
 * LeftSidebar.js (which rail renders) — they are siblings under
 * DashboardLayout with no shared state today, so this hook is the one place
 * the rule lives rather than two copies drifting apart.
 */
export default function useIsGroupConsole() {
  const user = useSelector(selectUser);
  const location = useLocation();
  return !!user?.group && !location.pathname.startsWith("/dashboard/admin");
}
